import * as React from 'react'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { useTranslation } from 'react-i18next'

type GeneralContactInputErrors = {
  generalEmail: string
  [key: string]: string
}

type GeneralContactFormProps = {
  email: string
  receiveRequestForProposals: boolean
  onEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onReceiveRequestForProposalsChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void
  formErrors: GeneralContactInputErrors
  isEdit?: boolean
}

const GeneralContactForm: React.FC<GeneralContactFormProps> = ({
  email,
  receiveRequestForProposals,
  onEmailChange,
  onReceiveRequestForProposalsChange,
  onBlur,
  formErrors,
  isEdit = false
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Box sx={{ mt: 3 }} display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2}>
        <TextField
          sx={{ gridColumn: { xs: '1 / span 3', sm: '1 / span 2' } }}
          autoFocus
          id="email"
          label={t('email')}
          type="email"
          name="generalEmail"
          fullWidth
          variant="filled"
          required
          value={email}
          onChange={onEmailChange}
          onBlur={onBlur}
          helperText={formErrors.generalEmail ? formErrors.generalEmail : ''}
          error={formErrors.generalEmail !== ''}
        />
      </Box>
      {isEdit && (
        <FormControlLabel
          sx={{ mt: 1 }}
          control={<Checkbox onChange={onReceiveRequestForProposalsChange} checked={receiveRequestForProposals} />}
          label={t('request-for-proposals-may-be-sent-to-this-address')}
        />
      )}
    </>
  )
}

export default GeneralContactForm
